import { fetchGetStateByStateKey } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';
import _ from 'lodash';

import {
    getApplicantTitle,
    getApplicantLastName,
    getApplicantFirstName
} from '../../../api/lendingAPI/CustomerStateAPIHelper';
import { getCountry } from '../../../iwIntlProvider/CountryProvider';
import { FormattedName } from '../../../iwIntlProvider/FormattedName';
import { useStateKey } from '../../../iwQueryClient/useStateKey';

const InternationalisedName = () => {
    const stateKey = useStateKey();
    const { data: { title, firstName, lastName } = {}, isLoading } = useQuery({
        queryKey: ['customer_state', stateKey],
        queryFn: () => fetchGetStateByStateKey({ stateKey }),
        select: ({ data }) => {
            return {
                title: getApplicantTitle(data),
                firstName: getApplicantFirstName(data),
                lastName: getApplicantLastName(data)
            };
        }
    });

    if (isLoading) return null;

    if (!(getCountry() === 'DE')) {
        return <FormattedName firstName={firstName} />;
    }

    return (
        <>
            {_.upperFirst(title)}
            &nbsp;
            <FormattedName lastName={lastName} />
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default InternationalisedName;
